export default function createWorkspaceMenu () {
  return {
    hot: {
      title: '热门功能',
      list: [
        { icon: 'el-icon-wenben-mianxing', text: '文本翻译', url: '/translate', type: 'txt' },
        { icon: 'el-icon-wendang', text: '文档翻译', url: '/translate', type: 'doc' },
        { icon: 'el-icon-rengongzhineng', text: 'AI翻译', url: '/translate', type: 'AITranslate' },
        { icon: 'el-icon-runse', text: '润色改写', url: '/translate', type: 'polish' },
        { icon: 'el-icon-a-aippt', text: 'AI PPT', url: '/translate', type: 'aiPPT' }
      ]
    },
    translate: {
      title: '翻译功能',
      list: [
        { icon: 'el-icon-daoyouyuzhong', text: '多语种翻译', url: '/translate', type: 'more' },
        { icon: 'el-icon-tupian', text: '图片翻译', url: '/translate', type: 'img' },
        { icon: 'el-icon-rengong', text: '人工翻译', url: '/trans-pro' }
      ]
    },
    doc: {
      title: '工具服务',
      list: [
        { icon: 'el-icon-shuyuku', text: '术语词库', url: '/translate', type: 'setting' },
        { icon: 'el-icon-a-16Dzhuanhuan', text: '文档转换', url: '/translate', type: 'convert' },
        { icon: 'el-icon-moban', text: '网页翻译', url: '/translate', type: 'plugin' },
        { icon: 'el-icon-connection', text: '数据分析', url: '/smart-classify' },
        { icon: 'el-icon-folder-opened', text: 'RAG知识库', url: '/rag' },
        { icon: 'el-icon-search', text: '聚合数据库检索', url: '/scholar' },
        { icon: 'el-icon-s-grid', text: '分类预测', url: '/category-tool' },
        { icon: 'el-icon-files', text: '素材提取', url: '/extract' }
      ]
    }
  }
}

export function createWorkspaceSideRailGroups () {
  const menu = createWorkspaceMenu()
  return Object.keys(menu).map(groupKey => ({
    key: groupKey,
    title: menu[groupKey].title,
    items: menu[groupKey].list.map(item => ({
      key: item.type || item.url,
      label: item.text,
      icon: item.icon,
      path: item.url,
      type: item.type,
      matchPrefix: item.url === '/scholar'
    }))
  }))
}
